import * as React from "react";
import { useTranslation } from "react-i18next";
import { UnauthLayout } from "../layouts/unauth-layout";
import { useLoginLogic } from "../../utils/auth-hooks";
import { GoogleAuthButton } from "../molecules/google-auth-button";
import { GrafferAuthButton } from "../molecules/graffer-auth-button";
import { LineAuthButton } from "../molecules/line-auth-button";
import { ExternalLink } from "@graffer-inc/graffer-design-kit";
import { Card } from "../molecules/card";
import { GBizIDLink } from "../atoms/gbizid-link";
import { SignupLink } from "../molecules/signup-link";
import { useTenant } from "../hooks/tenant-hooks";

export const LoginOAuth = () => {
  const { t } = useTranslation();
  const { locked } = useLoginLogic();
  const tenant = useTenant();

  return (
    <UnauthLayout title={t(`%%%ログイン%%%`)}>
      <h1
        className="has-text-weight-bold has-text-centered is-size-5 mb-4"
        style={{ lineHeight: "1.7" }}
      >
        {tenant?.name} ログイン
      </h1>
      <div className="mb-4">
        <Card title={"Grafferアカウントをお持ちの方"}>
          <p className="mb-4">
            <ExternalLink href="https://graffer.jp/legal/account-policy">
              Grafferアカウント規約
            </ExternalLink>
            <ExternalLink href="https://graffer.jp/legal/privacy-policy">
              プライバシーポリシー
            </ExternalLink>
            をお読みのうえ、同意してログインしてください。
          </p>
          <ul className="mb-4">
            <li className="mb-4">
              <GoogleAuthButton text={t(`%%%Googleでログイン%%%`)} />
            </li>
            <li className="mb-4">
              <LineAuthButton text={t(`%%%LINEでログイン%%%`)} />
            </li>
            <li>
              <GrafferAuthButton />
            </li>
          </ul>
          <div className="has-text-centered">
            <ExternalLink href="https://graffer.jp/faq/653f359c718ba8c14bada334">
              ログイン方法について教えてください
            </ExternalLink>
          </div>
        </Card>
      </div>
      <div className="has-text-centered is-size-7 mb-4">
        <span className="has-text-weight-bold">
          <GBizIDLink tenant={tenant} />
        </span>
      </div>
      {locked ? null : <SignupLink />}
    </UnauthLayout>
  );
};
